module.exports = __webpack_public_path__ + "static/media/air3.e76e0c4e.jpg";